import { ca } from '@cian/analytics';

export function trackSectionShown(sectionName: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Show_sopr',
    label: sectionName,
  });
}
